var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-16"},[_c('p',[_vm._v("Не найден компонент: "+_vm._s(_vm.component.type))])])}
var staticRenderFns = []

export { render, staticRenderFns }